export default "__VITE_ASSET__DL5wqX9d__"